document.addEventListener('DOMContentLoaded', () => {
  const calendar = document.getElementById('calendar');
  if (!calendar) return;

  const rawEvents = calendar.dataset.events.split(',').filter(Boolean);
  const eventMap = {};

  const validMonths = calendar.dataset.eventMonths
    .split(',')
    .filter(Boolean); // ["2025-07", "2025-08"]

  rawEvents.forEach(entry => {
    const parts = entry.split(':');
    const [date, handle, status] = parts.slice(0, 3);
    const encodedSaleEnd = parts.slice(3).join(':'); // saleEndは ":" を含む可能性あり
    const saleEnd = decodeURIComponent(encodedSaleEnd);
    eventMap[date] = { handle, status, saleEnd };
  });

  const holidays = [
    "2025-01-01", "2025-01-13", "2025-02-11", "2025-02-24",
    "2025-03-20", "2025-04-29", "2025-05-03", "2025-05-04",
    "2025-05-05", "2025-05-06", "2025-07-21", "2025-08-11", "2025-09-15",
    "2025-09-23", "2025-10-13", "2025-11-03", "2025-11-23", "2025-11-24"
  ];

  const urlParams = new URLSearchParams(window.location.search);
  let selectedDate = urlParams.get('selected') || null;

  if (!selectedDate) {
    const pathHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];
    if (pathHandle) {
      for (const [date, { handle }] of Object.entries(eventMap)) {
        if (handle === pathHandle) {
          selectedDate = date;
          break;
        }
      }
    }
  }

  // defaultYear/defaultMonth を初期値とする（Liquidから渡ってくる）
  let year = parseInt(calendar.dataset.defaultYear);
  let month = parseInt(calendar.dataset.defaultMonth) - 1;

  // ★ selectedDateがある場合はそれを優先する
  if (selectedDate) {
    const parts = selectedDate.split("-");
    if (parts.length >= 2) {
      year = parseInt(parts[0]);
      month = parseInt(parts[1]) - 1; // JavaScriptの月は0始まり
    }
  }

  const prevBtn = document.getElementById('prev-month');
  const nextBtn = document.getElementById('next-month');

  function updateNavButtonVisibility(year, month) {
    const prevMonthStr = `${year}-${String(month).padStart(2, '0')}`;
    const nextMonthStr = `${year}-${String(month + 2).padStart(2, '0')}`;

    prevBtn.classList.toggle('hidden', !validMonths.includes(prevMonthStr));
    nextBtn.classList.toggle('hidden', !validMonths.includes(nextMonthStr));
  }

  generateCalendar(year, month);
  updateNavButtonVisibility(year, month);

  prevBtn.addEventListener('click', () => {
    month--;
    if (month < 0) { month = 11; year--; }
    generateCalendar(year, month);
    updateNavButtonVisibility(year, month);
  });

  nextBtn.addEventListener('click', () => {
    month++;
    if (month > 11) { month = 0; year++; }
    generateCalendar(year, month);
    updateNavButtonVisibility(year, month);
  });

  function generateCalendar(year, month) {
    const tbody = document.getElementById('calendar-body');
    const title = document.getElementById('calendar-title');
    tbody.innerHTML = '';
    title.textContent = `${year}年 ${month + 1}月`;

    const currentMonthStr = `${year}-${String(month + 1).padStart(2, '0')}`;
    const prevMonthStr = `${year}-${String(month).padStart(2, '0')}`;
    const nextMonthStr = `${year}-${String(month + 2).padStart(2, '0')}`;
    
    document.getElementById('prev-month').style.visibility =
      validMonths.includes(prevMonthStr) ? 'visible' : 'hidden';
    
    document.getElementById('next-month').style.visibility =
      validMonths.includes(nextMonthStr) ? 'visible' : 'hidden';

    document.querySelectorAll('.calendar-table td.selected-date').forEach(td => {
      td.classList.remove('selected-date');
    });

    const firstDay = new Date(year, month, 1).getDay();
    const adjustedFirstDay = (firstDay + 6) % 7;
    const lastDate = new Date(year, month + 1, 0).getDate();
    let date = 1;

    for (let i = 0; i < 6; i++) {
      const row = document.createElement('tr');
      for (let j = 0; j < 7; j++) {
        const cell = document.createElement('td');
        if (i === 0 && j < adjustedFirstDay) {
          cell.innerHTML = '';
          cell.classList.add('no-event');
        } else if (date > lastDate) {
          cell.innerHTML = '';
          cell.classList.add('no-event');
        } else {
          const displayDate = `${year}-${String(month+1).padStart(2,'0')}-${String(date).padStart(2,'0')}`;
          cell.textContent = date;

          const weekDay = (new Date(year, month, date).getDay() + 6) % 7;
          if (weekDay === 5) cell.classList.add('saturday');
          if (weekDay === 6) cell.classList.add('sunday');
          if (holidays.includes(displayDate)) cell.classList.add('holiday');

          if (eventMap[displayDate]) {
            const { handle, status, saleEnd } = eventMap[displayDate];

          // sale_end をローカル時刻でパース。日付のみ or 00:00:00 は当日23:59:59.999まで有効
          function parseSaleEndLocalEnd(s) {
            if (!s) return null;
            const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2}))?/);
            if (!m) return null;
            const y = parseInt(m[1], 10);
            const mo = parseInt(m[2], 10) - 1;
            const d = parseInt(m[3], 10);

            if (!m[4] || (m[4] === '00' && m[5] === '00' && m[6] === '00')) {
              return new Date(y, mo, d, 23, 59, 59, 999);
            } else {
              const hh = parseInt(m[4], 10);
              const mm = parseInt(m[5], 10);
              const ss = parseInt(m[6], 10);
              return new Date(y, mo, d, hh, mm, ss, 999);
            }
          }

          const endAtFromMeta = parseSaleEndLocalEnd(saleEnd);
          const displayStart  = new Date(year, month, date, 0, 0, 0, 0);
          const displayEnd    = new Date(year, month, date, 23, 59, 59, 999);

          // フォールバック：metaのsale_endがこのセルの日付より「前日以前」なら、
          // そのセルの日の終わりまで有効として扱う（データ誤設定の救済）
          let endAt = endAtFromMeta;
          if (endAt && endAt < displayStart) {
            endAt = displayEnd;
          }

          const now = new Date();
          const isExpired = endAt ? (now > endAt) : false;

          if (saleEnd) {
            console.log('[saleEndDBG]', {
              displayDate,
              saleEnd,
              endAt: endAt ? endAt.toString() : null,
              now: now.toString(),
              isExpired,
              status
            });
          }

            // 表示マーク作成
            const mark = document.createElement('div');
            mark.classList.add('stock-mark');

            if (isExpired) {
              mark.textContent = '×';
              mark.title = '販売終了';
              mark.classList.add('stock-ng');
              cell.classList.add('soldout');
            } else {
              mark.textContent = status;
              if (status === '○') mark.classList.add('stock-ok');
              if (status === '△') mark.classList.add('stock-mid');
              if (status === '×') mark.classList.add('stock-ng');

              if (status !== '×') {
                cell.classList.add('available');
                cell.addEventListener('click', () => {
                  window.location.href = `/products/${handle}?selected=${displayDate}`;
                });
              } else {
                cell.classList.add('soldout');
              }
            }

            cell.appendChild(mark);

            if (displayDate === selectedDate) {
              cell.classList.add('selected-date');
            }
          } else {
            cell.classList.add('no-event');
            if (displayDate === selectedDate) {
              cell.classList.add('selected-date');
            }
          }
          date++;
        }
        row.appendChild(cell);
      }
      tbody.appendChild(row);
    }
    const rows = tbody.querySelectorAll('tr');
    rows.forEach(row => {
      const cells = Array.from(row.querySelectorAll('td'));
      const isEmptyRow = cells.every(td => td.innerHTML.trim() === '');
      if (isEmptyRow) {
        row.classList.add('hidden-row');
      }
    });
  }
});